<div id="orders" class="page-layout carded fullwidth ">
    <div class="top-bg primary"></div>
    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutGap="20px" fxLayoutAlign.gt-xs="space-between center">

            <!-- APP TITLE -->
            <div class="mat-display-1 my-0 my-sm-24 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'SESSION_LOG_LIST' |
                    translate}}</span>
            </div>
            <!-- / APP TITLE -->
            <div class="search-wrapper  ml-sm-32">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <input #filter [(ngModel)]="filterText" placeholder="{{'SEARCH' | translate}}">
                </div>
            </div>
            <div class="row"></div>
        </div>
        <!-- / HEADER -->

        <div class="content-card my-16" style="justify-content: space-between;">
            <div class="p-20">
                <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px;" #table
                    [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}" matSortActive="date"
                    matSortDirection="desc" fusePerfectScrollbar>

                    <!-- Username Column -->
                    <ng-container matColumnDef="username">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'USERNAME'|translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let session">
                            {{session.username!=null?session.username:'---'}}
                        </mat-cell>
                    </ng-container>

                    <!-- Ip Column -->
                    <ng-container matColumnDef="ipAddress">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'IP_ADDRESS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let session">
                            {{session.ipAddress!=null?session.ipAddress:'---'}}
                        </mat-cell>
                    </ng-container>

                    <!-- browser Column -->
                    <ng-container matColumnDef="browser">
                        <mat-header-cell *matHeaderCellDef>{{'BROWSER_INFORMATION'|translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let session">
                            <div fxLayout="column" fxLayoutAlign="start">
                                <div style="margin: 10px 0px;">
                                    <b>User Agent : </b>
                                    <span>{{session.userAgent!=null?session.userAgent:'---'}}</span>
                                </div>
                                <div style="margin: 10px 0px;">
                                    <b>Browser : </b>
                                    <span>{{session.browserName!=null?session.browserName:'---'}}</span>
                                </div>
                                <div style="margin: 10px 0px;">
                                    <b>Version : </b>
                                    <span>{{session.browserVersion!=null?session.browserVersion:'---'}}</span>
                                </div>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <!-- date Column -->
                    <ng-container matColumnDef="date">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'DATE'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let session">
                            {{session.date!=null?(session.date |date:"dd/MM/y HH:mm":'+600'):'---'}}
                        </mat-cell>
                    </ng-container>


                    <!-- setting Column -->
                    <ng-container matColumnDef="setting">
                        <mat-header-cell *matHeaderCellDef>{{'SETTINGS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let session">
                            <button mat-icon-button [matMenuTriggerFor]="menu"
                                aria-label="Example icon-button with a menu">
                                <mat-icon>settings</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="deleteSession(session)">
                                    <mat-icon>delete</mat-icon>
                                    <span>{{'DELETE'|translate}}</span>
                                </button>
                            </mat-menu>
                        </mat-cell>
                    </ng-container>


                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let device columns: displayedColumns;" class="order" matRipple>
                    </mat-row>
                </mat-table>

                <mat-paginator #paginator [length]="paginator.length" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
                </mat-paginator>
            </div>
        </div>
    </div>
    <!-- / CENTER -->
</div>